import { useSyncExternalStore } from "react";
import { isRegionNotOffered } from "@pushback-and-chaos/contracts";

/**
 * THE REGION GATE'S REFUSAL, WHEREVER IT CAME FROM (Andre's answers of
 * 2026-10-28). The api answers every gated door (a new guest, sign-up, AJ's
 * intake, the coach, practice, dictation, read-aloud, a turn, a case) from the
 * EU, the EEA or the UK with the same 451 REGION_NOT_OFFERED. The client tells
 * this of every refusal it reads (packages/client's `onProblem`, wired in
 * data/transport.ts), so one is noticed whichever screen, query or button made
 * the request, and the app gives way to its one screen (ui/region-not-offered.tsx)
 * until the page is reloaded. Nothing here asks the server anything.
 */
let refusals = 0;
const listeners = new Set<() => void>();

/** Notes a refusal the client read; only the region gate's counts. */
export function noteRefusal(problem: { readonly status: number; readonly code: string }): void {
  if (!isRegionNotOffered(problem)) return;
  refusals += 1;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * How many times the region gate has refused this page since it was loaded:
 * none, or a count that moves with each refusal, so a refusal heard after the
 * learner followed one of the screen's doors brings the screen back.
 */
export function useRegionRefusals(): number {
  return useSyncExternalStore(
    subscribe,
    () => refusals,
    () => refusals,
  );
}

/** For tests: the page as it was loaded, refused by nothing yet. */
export function forgetRegionRefusal(): void {
  refusals = 0;
  for (const listener of listeners) listener();
}
